var map = {
	"./components/UxGuide/UxGuidelines/examples/accessibility-bad.png": 46216,
	"./components/UxGuide/UxGuidelines/examples/accessibility-good.png": 76907,
	"./components/UxGuide/UxGuidelines/examples/alignment-bad.png": 82838,
	"./components/UxGuide/UxGuidelines/examples/alignment-good.png": 66203,
	"./components/UxGuide/UxGuidelines/examples/loading-bad.png": 58107,
	"./components/UxGuide/UxGuidelines/examples/loading-good.png": 49532,
	"./components/UxGuide/UxGuidelines/examples/onboarding-bad.png": 47762,
	"./components/UxGuide/UxGuidelines/examples/onboarding-good.png": 16346,
	"./components/UxGuide/UxGuidelines/examples/onboarding-sidebar-bad.png": 86331,
	"./components/UxGuide/UxGuidelines/examples/onboarding-sidebar-good.png": 57173,
	"./components/UxGuide/UxGuidelines/examples/performance-bad.png": 91532,
	"./components/UxGuide/UxGuidelines/examples/performance-good.png": 53343,
	"./components/UxGuide/UxGuidelines/examples/theme-bad.png": 51811,
	"./components/UxGuide/UxGuidelines/examples/theme-good.png": 68497,
	"./components/UxGuide/UxGuidelines/useThinkFeel.png": 84105,
	"./resources/images/Octopus-96x96.png": 57053,
	"./resources/images/octo-surfer-200.png": 18276
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56578;